// extracted by mini-css-extract-plugin
export default {"product":"_4RHgq","productForFrameless":"_14vgQ","errorMessage":"_1T2KH"};